import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { useGetters } from 'vuex-composition-helpers'
import { getExtensionSchema, getExtensionDataSchema } from '@/api/schemas.js'
import { extractFieldsFromSchema } from '@/utils/field-schema-helper'
import SubmissionField from '@/components/forms/submission-fields/SubmissionField.vue'
import { useQueryClient } from '@tanstack/vue-query'
import moment from 'moment'

/**
 * `extensionSchemaId` is not backfilled in the tickets DB table. In that case,
 * even if the feature flag is on, we will always download the latest schema
 * tied to the Activity and Division.
 */
interface JobExtensionDataProps {
  data?: any
  activityId: number
  divisionId: string
  extensionSchemaId?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'JobExtensionData',
  props: {
    data: { default: {} },
    activityId: null,
    divisionId: null,
    extensionSchemaId: null
  },
  setup(__props: any) {

const props = __props as { data: any, activityId: number, divisionId: string, extensionSchemaId?: number }

onMounted(async () => {
  if (props.extensionSchemaId) {
    const f = {} // Gets mutated by recursive extractFieldsFromSchema
    const response = await getExtensionSchema(props.extensionSchemaId)
    const versionedSchema = response.data as Record<string, any>

    extractFieldsFromSchema(
      versionedSchema?.schema ?? {},
      versionedSchema?.uiSchema ?? {},
      f
    )
    fields.value = f
  } else {
    const f = {} // Gets mutated by recursive extractFieldsFromSchema
    const latestSchema = await client.fetchQuery({
      queryKey: ['schemas', props.activityId, props.divisionId],
      queryFn: () =>
        getExtensionDataSchema(props.divisionId, props.activityId).then(
          (r) => r.data
        ),
      staleTime: moment.duration(10, 'minutes').asMilliseconds(),
    })

    extractFieldsFromSchema(
      latestSchema?.schema ?? {},
      latestSchema?.uiSchema ?? {},
      f
    )
    fields.value = f
  }
})

const client = useQueryClient()
const fields = ref<Record<string, any>>({})


return { __sfc: true,client, fields, props, SubmissionField }
}

})